'use client';

import { LottolandSmileLogo } from '@shared/icons';
import { IconBadge } from '../../../IconBadge/IconBadge';
import { Selector } from '../../../SelectorGroup';
import type { OptionsProps } from '../../types';

function Options({ options, selectedOption, onOptionClick, title, ...props }: OptionsProps) {
  return (
    <div className="flex flex-col gap-5 px-6 pt-10 h-full md:h-auto overflow-y-auto" {...props}>
      <div aria-hidden="true">
        <IconBadge icon={LottolandSmileLogo} shapeType="square" />
      </div>
      <div className="flex flex-col gap-10 flex-grow">
        <h2 id="whyLeavingOptionsTitle" className="heading-4 text-foreground">
          {title}
        </h2>
        <div className="flex flex-col gap-2" role="group" aria-labelledby="whyLeavingOptionsTitle" data-track-container="Options">
          {options.map(option => (
            <Selector
              key={option.value}
              data-testid={`why-leaving-option-${option.value}`}
              value={option.value}
              selected={selectedOption === option.value}
              onClick={() => onOptionClick(option.value)}
              data-track-name={option.label}
            >
              <span className="paragraph-explanatory-strong">{option.label}</span>
            </Selector>
          ))}
        </div>
      </div>
    </div>
  );
}

export { Options };
